const template = document.createElement('template');

template.innerHTML = `
  <div class="notification-wrapper">
    <i class="icon-x_close_icon icon-close"></i>
    <div class="notification-wrapper__title"></div>
    <div class="notification-wrapper__text"></div>
  </div>
`;

class NotificationComponent extends HTMLElement {

  _notificationWrapperEl;
  _iconCloseEl;
  _titleEl;
  _textEl;

  connectedCallback() {
    this.appendChild(template.content.cloneNode(true));

    this._notificationWrapperEl = this.querySelector('.notification-wrapper');
    this._iconCloseEl = this.querySelector('.icon-close');
    this._titleEl = this.querySelector('.notification-wrapper__title');
    this._titleEl = this.querySelector('.notification-wrapper__title');
    this._textEl = this.querySelector('.notification-wrapper__text');

    this._notificationWrapperEl.classList.add(`notification-wrapper--${ this.getAttribute('type') }`);
    this._titleEl.innerHTML = this.getAttribute('title');
    this._textEl.innerHTML = this.getAttribute('text');

    this.iconCloseClickListener();
  }

  static get observedAttributes() {
    return ['type', 'title', 'text'];
  }

  iconCloseClickListener() {
    this._iconCloseEl.addEventListener('click', this.close.bind(this));
  }

  close() {
    this.remove();
  }
}

window.customElements.define('cc-notification', NotificationComponent);
